// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"186c0e4b","513":"11e7dd25","787":"9fedaaca"}[chunkId] + ".chunk.js";
};